<template>
  <div></div>
</template>

<script>
import { getDeviceInfo, getLocale, selectLanguage } from '@/utils'

export default {
  name: 'AuthToken',
  computed: {
    params: function() {
      let params = {device: getDeviceInfo(), locale: getLocale()}

      if ('start' in this.$route.params) {
        params.step = this.$route.params.start
      } else if ('step' in this.$route.params) {
        params.step = this.$route.params.step
      }

      ['tracking_source', 'sid1', 'sid2', 'sid3', 'language'].forEach(key => {
        if (key in this.$route.query) {
          params[key] = this.$route.query[key]
        }
      })

      return params
    }
  },
  created() {
    console.log('authorize the session.')
    let params = Object.assign({uid: this.$route.params.uid, token: this.$route.params.token}, this.params)

    if (params['language']) {
      selectLanguage(params['language'].toString().toLowerCase())
    }

    this.$store.dispatch('authorize', params)
      .then(session => {
        console.log(session)
        if (this.$route.query.is_chatbot_embed) {
          this.$router.replace({name: 'chatbot-embed'})
        } else if (session.can_enter_exit_lifeline) {
          history.replaceState(null, null, '/undo')
          this.$router.push({name: 'session'})
        } else {
          this.$router.replace({name: 'session'})
        }
      })
      .catch(err => {
        console.log(err)
        this.$store.commit('clear_messages') // we're redirecting to anonymous session start, so don't show messages

        let startParams = ('step' in params) ? {step: params.step} : {}
        this.$router.replace({name: 'session-start', params: startParams, query: this.$route.query})
      })
  }
}
</script>

<style scoped>

</style>
